/**
 * @fileoverview useDictationEnabled — whether this deployment offers voice
 * dictation (MOR-2302, C4).
 *
 * Dictation runs on OpenAI's Realtime API, so the enterprise instances set
 * `DICTATION_ENABLED=false` on the Convex deployment. The browser cannot read
 * that variable; `features/queries.ts` reports it. The answer is `false`
 * until the query has loaded, so a deployment with dictation off never
 * shows the button, even for a moment.
 */

import { useQuery } from "convex/react";
import { api } from "@cvx/_generated/api";

export function useDictationEnabled(): boolean {
  const features = useQuery(api.features.queries.getDeploymentFeatures);
  return features?.dictationEnabled === true;
}
